import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=1bcb82df&scoped=true&"
import script from "./CustomerIndex.vue?vue&type=script&lang=js&"
export * from "./CustomerIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomerIndex.vue?vue&type=style&index=0&id=1bcb82df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb82df",
  null
  
)

export default component.exports